<template>
  <LegalAndPrivacyLayout headingLocalizerKey="terms_of_use_header"
                         titleKVP="hbs_flow_title"
                         :policyType="policyType"
                         scrollable
                         back-icon-list="fa-solid fa-house-circle-xmark"
                         class-list="canary setup terms"
                         :showTitle="true"
                         :onBackClick="onAbandonClick">

    <template v-slot:auxiliary>
      <zbm-btn-icon @click="onInfoClick()" icon="fa-regular fa-question-circle" size="24px" text-color="dark-teal"
                    data-testid="backArrow"/>
    </template>

    <template v-slot:actions>
      <div class="row" style="margin-top: 48px">
        <div class="col">
          <!-- Checkbox -->
          <zbm-checkbox v-model="checked" id="userPolicyCheck" name="userPolicyCheck">
            {{ t('canary_terms_of_use') }}
          </zbm-checkbox>
        </div>
      </div>

      <div class="col canary-continue">
        <zbm-btn :color="$zb.enums.ButtonStdColorEnum.accent"
                 :label="t('acc_gen_continue')"
                 :outline="true"
                 :disabled="!checked"
                 :width="$zb.enums.ButtonWidthEnum.wFull"
                 :height="$zb.enums.ButtonHeightEnum.lg"
                 @click="onNextClick"/>
      </div>

    </template>

  </LegalAndPrivacyLayout>

  <the-abandon-modal v-model="showAbandon"/>
  <the-contact-modal v-model="showContact"/>
</template>

<script lang="ts" setup>
import {onMounted, ref} from 'vue';
import {handleApiRequest} from 'src/api/handleApiRequest';
import LegalAndPrivacyLayout from 'src/components/layouts/LegalAndPrivacyLayout.vue';

import {getNextActivationRoute} from 'src/services/piqSetupService';
import {UserPolicyType} from 'src/constants/enums';
import {updatePolicy} from 'src/api/endpoints/registrationWeb';

import {useGeneralPurposeModalStore} from 'src/store';
import {createDecisionModal} from 'src/utils/generalPurposeModalFactory';
import {useRouter} from 'vue-router';
import {useQuasar} from 'quasar';
import {useI18n} from 'vue-i18n';
import TheContactModal from '@/components/TheContactModal.vue';
import TheAbandonModal from '@/components/TheAbandonModal.vue';

const $q = useQuasar()
const generalPurposeModalStore = useGeneralPurposeModalStore()
const router = useRouter();

const checked = ref(false);
const {t} = useI18n();
const policyType = ref<UserPolicyType>(UserPolicyType.CanaryPiqTermsOfUse);

const showAbandon = ref(false);
const showContact = ref(false);

onMounted(async () => {
  checked.value = false;
})

// methods
async function onNextClick() {
  if (checked.value) {
    $q.loading.show();

    const response = await handleApiRequest(() =>
      updatePolicy(policyType.value, false, true), null, $q
    ).finally(() => {
      $q.loading.hide();
    });

    if (!response?.result) {
      // error
    } else {
      var nextRoute = await getNextActivationRoute($q);
      router.push({name: nextRoute}).catch(() => {
      });
    }
  } else {
    $q.loading.hide();
    const info = createDecisionModal('', t('piq_t_c_error'));
    generalPurposeModalStore.setModal(info);
  }
}

async function onAbandonClick() {
  showAbandon.value = !showAbandon.value;
}

async function onInfoClick() {
  showContact.value = !showContact.value;
}
</script>
